import { VALIDATION_ERROR_KEYS } from "@/i18n"
import {
  boolean,
  optionalString,
  requiredString,
} from "@/lib/zod-schemas/literals"
import * as z from "zod"

export const validationSchema = z.object({
  invite_only: boolean,
  priority_uuid: z.uuid(VALIDATION_ERROR_KEYS.REQUIRED),
  start_date: z.iso.date(VALIDATION_ERROR_KEYS.REQUIRED),
  end_date: z.iso.date().nullable(),
  details: z.object({
    title: requiredString,
    description: optionalString,
    tag_ids: z.array(z.string()),
  }),
})

export type ListingFormSchema = z.output<typeof validationSchema>
